/**
 * Settings Page
 * User settings and preferences (placeholder)
 */

export function SettingsPage() {
  return (
    <div className="flex-1 p-8 overflow-auto bg-zinc-950">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-white mb-4">Settings</h1>
        <p className="text-gray-400">
          User settings interface coming soon...
        </p>
      </div>
    </div>
  );
}
